;(function( window, document, $, undefined ) {
	'use strict';

	// Position Element

	function positionElements() {

    // Mobile
    function mobile( $el, $target ) {
      $el.each(function() {
        var $this = $(this);
        var elClone = $this.clone();

        $this.closest( $target ).prepend( elClone.addClass('hideAboveTablet') );
        $this.addClass('hideBelowTablet');
      });
    }

		// Globals
		return {
      mobile: mobile
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.positionElements = positionElements();

})( window, document, jQuery );
